// extracted by mini-css-extract-plugin
export default {"content":"NotFound_content__ZeP5H","notfound":"NotFound_notfound__gm+YY"};